module.exports = __webpack_public_path__ + "media/images/Logo-hvit-3980efcdc734ddf3b948d898382105c8.svg";